import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Circle, Radio } from 'react-feather';
import { Button, Row, Table } from 'reactstrap';
import styled from '@emotion/styled';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import ImageLoader from 'components/Image';
import { useRouter } from 'next/router';
import {
  showToastError,
  showToastSuccess,
} from '@core/components/toastify/ToastTypes';
import liveSessionApi from 'api/liveSessionApi';
import { LIMIT_GET_LIST_CLASS, USER_ROLES } from 'constants/constants';
import styles from 'styles/Course.module.scss';
import classnames from 'classnames';
import userEventApi from 'api/userEventApi';
import { getIconFromType, handleToastError } from 'helpers';
import { getViewMode } from 'store/auth';
import ModalZoom from '../../Course/Unit/components/ContentCalendar/modalZoomLink';
import { getSelectedCentre } from 'store/master';
import ListTableRow from 'components/Table/ListTableRow';
import FooterTableCustom from 'components/Table/FooterTableCustom';
import LoadingOverlay from 'react-loading-overlay';
import sessionUserApi from 'api/sessionUserApi';
import { useUser } from 'hooks';
import { omitViewModes } from 'hooks/permission';
import Swal from 'sweetalert2';
import { accessDenied } from 'modules/Course/CourseDetail/optimizedDetailPage/lesson-access-modal';
import ReactDOMServer from 'react-dom/server';
import moment from 'moment';
import { formatDDMMYYYYHHMM } from 'helpers/format-time';
const LiveClasses = () => {
  const themeStatus = useSelector(getThemeColor);
  const router = useRouter();
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const userLoggedIn = useUser();
  const [isBusy, setBusy] = useState(true);
  const [isLive, setIsLive] = useState();
  const [openZoom, setOpenZoom] = useState(false);
  const [zoomLink, setZoomLink] = useState();
  const viewMode = useSelector(getViewMode);
  const selectedCentre = useSelector(getSelectedCentre);
  const [rowPerPage, setRowPerPage] = useState(4);
  const [disableStatus, setDisableStatus] = useState(true);

  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
      border-color: ${colorStatus} !important;
    }
    .btn-danger:disabled {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn {
      padding: 0.3rem 0.9rem !important;
      font-size: 12px !important;
      border-radius: 0.3rem !important;
    }
  `;
  const FetchLiveClassAdmin = async (page = 1) => {
    try {
      await setBusy(true);
      const params = {
        page,
        rowPerPage: rowPerPage,
      };
      if (selectedCentre?._id) {
        params.courseCentre = selectedCentre?._id;
      }
      const response = omitViewModes(viewMode, {
        omitValues: [USER_ROLES.LEARNER],
        addValues: [USER_ROLES.ADMIN],
      })
        ? await liveSessionApi.get(params)
        : await userEventApi.getLiveClassRunning(params);

      if (response?.totalItems > 4) {
        response.data = response?.data?.slice(0, 2);
        setRowPerPage(2);
      }
      setIsLive(response);
      await setBusy(false);
    } catch (e) {
      showToastError(e);
    }
  };

  useEffect(() => {
    FetchLiveClassAdmin();
  }, [selectedCentre?._id]);

  const joinRoom = async (data) => {
    // toggle();
    try {
      const payload = await userEventApi.getLink(data);
      if (payload.data) {
        setZoomLink(payload.data);
        setOpenZoom(true);
      }
    } catch (e) {
      handleToastError(e);
    }
  };

  const registrations = async (data) => {
    try {
      setDisableStatus(false);
      if (data?.sessionusers?.missingUserCourse) {
        const param = {
          session: data?._id,
          unit: data?.unit?._id,
          user: userLoggedIn._id,
        };
        const response = await sessionUserApi.create(param);
        if (response) {
          setDisableStatus(false);
        }
        showToastSuccess('Registered');
        FetchLiveClassAdmin();
      } else {
        const response = await sessionUserApi.delete(data?.sessionusers?._id);
        if (response) {
          setDisableStatus(false);
        }
        showToastSuccess('UnRegistered');
        FetchLiveClassAdmin();

        setDisableStatus(true);
      }
    } catch (error) {
      handleToastError(error);
    } finally {
      setDisableStatus(true);
    }
  };

  const onToggle = async () => {
    setOpenZoom(!openZoom);
  };

  const handleLessonAccess = (data) => {
    const isLearner = viewMode === USER_ROLES.LEARNER;
    const startDate = moment(data?.unit?.time?.begin);
    const now = moment();

    const IsBefore = now.isBefore(startDate);

    if (isLearner && IsBefore) {
      accessDenied(
        `This lesson will be accessible at the scheduled time. <br />
         Start Date: <strong> ${formatDDMMYYYYHHMM(
           data?.unit?.time?.begin,
         )} </strong> ${
          data?.unit?.time?.due
            ? `| Due Date: <strong> ${formatDDMMYYYYHHMM(
                data?.unit?.time?.due,
              )} </strong>`
            : ''
        }   | End Date: <strong>  ${formatDDMMYYYYHHMM(
          data?.unit?.time?.end,
        )} </strong> `,
        {
          confirmButtonColor: themeStatus,
        },
      );
      return true;
    }
    return false;
  };
  return (
    <React.Fragment>
      <div>
        <label className="view-page-title mt-1 ml-1">Online</label>
        <div className="">
          <LoadingOverlay
            active={isBusy}
            spinner
            styles={{
              overlay: (base) => ({
                ...base,
                background: 'rgb(187 181 181 / 50%)',
              }),
            }}
          >
            {isLive?.data?.length ? (
              <>
                {isLive?.totalItems < 5 ? (
                  isLive?.data?.map((live, i) => (
                    <>
                      <div
                        key={i}
                        className={`${
                          i % 2 === 0 ? 'instructor-container' : ''
                        } d-flex flex-row flex-nowrap align-items-center pt-50 `}
                      >
                        {live?.titleExtenstion ? (
                          <span
                            className={classnames(
                              'flashit1',
                              styles['flashit1'],
                            )}
                          >
                            <Radio
                              className="ml-1 mb-50"
                              color="#db0506"
                              size={18}
                            />
                          </span>
                        ) : (
                          <Radio
                            className="ml-1 mb-50"
                            color="#db0506"
                            size={18}
                          />
                        )}
                        <div className="ml-2 w-100">
                          <h5
                            title={
                              live?.name && live?.name + live?.titleExtenstion
                            }
                            className="lesson-label-tittle mb-0 line-clamp"
                          >
                            {live?.name && live?.titleExtenstion
                              ? `${live?.name} ${live?.titleExtenstion}`
                              : ''}
                          </h5>
                          <p
                            title={live?.intakeName}
                            className="lesson-label-tittle_email mb-0"
                          >
                            {live?.course?.name?.length > 30
                              ? `${live?.course?.name?.slice(0, 30)}...`
                              : live?.course?.name}
                          </p>
                        </div>
                        <div className="mx-0 d-flex align-items-center mr-1 my-1">
                          {!metaData?.zoomInside &&
                            live?.optionUser == 'REGISTRY' &&
                            viewMode === USER_ROLES.LEARNER && (
                              <Stylescal>
                                <button
                                  className={classnames(`btn btn-danger mr-1`)}
                                  onClick={() => registrations(live)}
                                >
                                  {live?.sessionusers?.missingUserCourse
                                    ? 'Register'
                                    : 'UnRegister'}
                                </button>
                              </Stylescal>
                            )}
                          <Stylescal>
                            <Button
                              color={'danger'}
                              disabled={
                                viewMode === USER_ROLES.LEARNER
                                  ? live?.sessionusers?.missingUserCourse
                                  : false
                              }
                              onClick={() => {
                                // if (handleLessonAccess(live)) return null;
                                if (
                                  typeof live?.preRequisiteAccess ==
                                    'boolean' &&
                                  !live?.preRequisiteAccess
                                ) {
                                  let lessonNames = '';
                                  for (const element of live?.preRequisiteLessons) {
                                    const iconHTML =
                                      ReactDOMServer.renderToString(
                                        getIconFromType(element.type),
                                      );
                                    lessonNames += `<li class="text-truncate" style="padding: 5px 7px;margin: 5px 0px;font-size:14px; background-color: #F3F3F3; color: #55636e;" title="${element.title}">${iconHTML}&nbsp;&nbsp;${element.title}</li>`;
                                  }
                                  handleLessonAccess(lessonNames, {
                                    confirmButtonText: 'Okay',
                                    confirmButtonColor: themeStatus,
                                    cancelButtonColor: 'secondary',
                                    showCancelButton: false,
                                    focusConfirm: true,
                                    didOpen: () => {
                                      const icon = document.querySelector(
                                        '.swal2-icon.swal2-info',
                                      );
                                      icon.style.color = 'red';
                                      icon.style.borderColor = 'red';
                                    },
                                  });
                                  return;
                                }

                                (!live?.sessionusers?.missingUserCourse ||
                                  viewMode !== USER_ROLES.LEARNER) &&
                                  joinRoom(live?._id);
                              }}
                            >
                              <span>Join</span>
                            </Button>
                          </Stylescal>
                        </div>
                      </div>
                    </>
                  ))
                ) : (
                  <div className="overflow-x-auto">
                    <Table responsive style={{ marginBottom: '0rem' }}>
                      <tbody>
                        <ListTableRow col={2} length={isLive?.data?.length}>
                          {isLive?.data?.map((live, index) => (
                            <tr key={index}>
                              <td
                                className="text-left"
                                title={live?.titleExtenstion}
                                data-th
                              >
                                <div className="d-flex">
                                  {live?.titleExtenstion ? (
                                    <span
                                      className={classnames(
                                        'flashit1',
                                        styles['flashit1'],
                                      )}
                                    >
                                      <Radio
                                        className="ml-1 mb-50"
                                        color="#db0506"
                                        size={18}
                                      />
                                    </span>
                                  ) : (
                                    <Radio
                                      className="ml-1 mb-50"
                                      color="#db0506"
                                      size={18}
                                    />
                                  )}
                                  <div className="ml-2 w-100">
                                    <h6
                                      title={live?.titleExtenstion}
                                      className="lesson-label-tittle mb-0"
                                    >
                                      {live?.titleExtenstion}
                                    </h6>
                                    <p
                                      title={live?.course?.name}
                                      className="lesson-label-tittle_email mb-0"
                                    >
                                      {live?.course?.name}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td style={{ textAlign: 'end' }}>
                                <Stylescal>
                                  <Button
                                    color={'danger'}
                                    className="mr-1 mb-50"
                                    onClick={() => {
                                      // if (handleLessonAccess(live)) return null;
                                      joinRoom(live?._id);
                                    }}
                                  >
                                    <span>Join</span>
                                  </Button>
                                </Stylescal>
                              </td>
                            </tr>
                          ))}
                        </ListTableRow>
                      </tbody>
                    </Table>
                    <FooterTableCustom
                      pageCount={isLive?.totalPage}
                      currentPage={isLive?.currentPage}
                      totalItems={isLive?.totalItems}
                      currentItem={isLive?.data?.length}
                      isBusy={isBusy}
                      changePath
                      showInputSearch={false}
                      onChange={FetchLiveClassAdmin}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="noliveclass_ui">
                <ImageLoader
                  width=""
                  height=""
                  src={'/images/NoLiveclass.png'}
                />
                <label className="view-page-title mt-1 ml-1">
                  There will be No Online Class
                </label>
              </div>
            )}
          </LoadingOverlay>
        </div>
        <ModalZoom open={openZoom} toggle={onToggle} link={zoomLink} />
      </div>
    </React.Fragment>
  );
};

export default LiveClasses;
